import type { IScenario } from 'commonTypes/api/scenarios/scenario';

import { allowedScenarios } from 'entities/scenario/config';

export const isAllowedScenario = (step: IScenario['step']) => allowedScenarios.includes(step);
